var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.render,{tag:"component",attrs:{"fill":_vm.fill}})}
var staticRenderFns = []

export { render, staticRenderFns }